import { createMutation, createQuery } from 'react-query-kit';

import { BASE_URL, fetchData } from 'services/http/http';
import { buildFilterUrl } from 'support/helpers/urls/urls';
import portalSchema from 'support/types/schema-portal';
import { FilterValue } from 'components/ListTable/types';

export const MESSAGES_QUERY_KEY = '/messages';

export type GetMessageResponse =
  portalSchema.paths['/v1/messages/{messageId}']['get']['responses']['200']['content']['application/json'];

export const useMessage = createQuery<GetMessageResponse, { messageId: string | undefined }, Error>({
  primaryKey: '/messages/:messageId',
  queryFn: async ({ queryKey: [, { messageId }] }) => {
    const { data } = await fetchData<GetMessageResponse>(`/v1/messages/${messageId}`);
    return data;
  },
  enabled: (_, { messageId }) => !!messageId,
});

export type GetMessageWithProcessSpecificationResponse =
  portalSchema.paths['/v2/messages/{messageId}']['get']['responses']['200']['content']['application/json'];
export const useMessageWithProcessSpecification = createQuery<
  GetMessageWithProcessSpecificationResponse,
  { messageId: string | undefined },
  Error
>({
  primaryKey: '/messages/v2/:messageId',
  queryFn: async ({ queryKey: [, { messageId }] }) => {
    const { data } = await fetchData<GetMessageWithProcessSpecificationResponse>(`/v2/messages/${messageId}`);
    return data;
  },
  enabled: (_, { messageId }) => !!messageId,
});

export type UpdateMessageRequest =
  portalSchema.paths['/v1/messages/{messageId}']['put']['requestBody']['content']['application/json'];
export type UpdateMessageResponse =
  portalSchema.paths['/v1/messages/{messageId}']['put']['responses']['200']['content']['application/json'] & {
    aaa: number;
  };
export const useUpdateMessage = createMutation<
  UpdateMessageResponse,
  { messageId: string; data: UpdateMessageRequest },
  Error
>({
  mutationFn: async ({ messageId, data }) => {
    const { data: responseData } = await fetchData<UpdateMessageResponse>(`/v1/messages/${messageId}`, {
      method: 'put',
      data,
    });
    return responseData;
  },
});

export const downloadReconciliationSummary = async (filterValues: Array<FilterValue>) => {
  const urlParams = buildFilterUrl({ filterValues }, { forApiRequest: true });
  return window.open(`${BASE_URL}v1/messages/reconciliation${urlParams}&export=true`, '_blank');
};

type GetDocTypeProcessSpecificationResponse =
  portalSchema.paths['/v1/messages/{type}/default-process-spec']['get']['responses']['200']['content']['application/json'];
export const useDocTypeProcessSpecification = createQuery<
  GetDocTypeProcessSpecificationResponse['data'],
  { docType: DocumentType },
  Error
>({
  primaryKey: `${MESSAGES_QUERY_KEY}/default-process-spec`,
  queryFn: async ({ queryKey: [_, variables] }) => {
    const { data } = await fetchData<GetDocTypeProcessSpecificationResponse>(
      `/v1/messages/${variables.docType}/default-process-spec`,
    );
    return data.data;
  },
  enabled: (_, variables) => !!variables.docType,
});
